"use strict";

export default class Preloader {
  constructor() {
    this.imageMap = {};
  }

  clear() {
    this.imageMap = {};
  }

  addUrls(...urls) {
    urls.map((url) => this.addUrl(url));
  }

  addUrl(url) {
    if (url in this.imageMap) {
      return;
    }

    const image = new Image();
    image.src = url;
    this.imageMap[url] = image;
  }
}
